type DirResult = overwolf.io.DirResult;
type ExistsResult = overwolf.io.ExistsResult;
type FileExistsResult = overwolf.io.FileExistsResult;
type ReadTextFileResult = overwolf.io.ReadTextFileResult;
type ReadFileContentsResult = overwolf.io.ReadFileContentsResult;
type ReadFileOptions = overwolf.io.ReadFileOptions;
type Encoding = overwolf.io.enums.eEncoding;

// -----------------------------------------------------------------------------
export class OWIO {
  // ---------------------------------------------------------------------------
  public static copyFile(
    src: string,
    dst: string,
    overrideFile: boolean,
    reserved: boolean
  ): Promise<boolean> {
    return new Promise(resolve => {
      overwolf.io.copyFile(src, dst, overrideFile, reserved, result => {
        return resolve(result.success);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static dir(path: string): Promise<DirResult> {
    return new Promise((resolve, reject) => {
      overwolf.io.dir(path, result => {
        return resolve(result);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static exist(path: string): Promise<ExistsResult> {
    return new Promise((resolve, reject) => {
      overwolf.io.exist(path, result => {
        return resolve(result);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static fileExists(filePath: string): Promise<FileExistsResult> {
    return new Promise((resolve, reject) => {
      overwolf.io.fileExists(filePath, result => {
        return resolve(result);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static readTextFile(path: string, options: ReadFileOptions)
  : Promise<ReadTextFileResult> {
    return new Promise((resolve, reject) => {
      overwolf.io.readTextFile(path, options, result => {
        return resolve(result);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static writeFileContents(
    filePath: string,
    content: string,
    encoding: Encoding,
    triggerUacIfRequired?: boolean
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      overwolf.io.writeFileContents(
        filePath, content, encoding, triggerUacIfRequired, result => {
          return resolve(result.success);
        }
      );
    });
  }

  // ---------------------------------------------------------------------------
  public static readFileContents(filePath: string, encoding: Encoding)
  : Promise<ReadFileContentsResult> {
    return new Promise((resolve, reject) => {
      overwolf.io.readFileContents(filePath, encoding, result => {
        return resolve(result);
      });
    });
  }
}
